<template>
<div style="margin-top: 113px" v-if="review">
  <v-container>
    <v-snackbar v-model="isMsg" :color="getColor()">
      <b>{{ message }} </b>
    </v-snackbar>
    <v-card>
      <v-card-title> Review workflow {{ review.user.firstName }} {{ review.user.lastName }} </v-card-title>
      <v-card-text>
        <p>Strong line manager : {{ review.slmanager!=undefined?review.slmanager.firstName:'' }} {{ review.slmanager!=undefined?review.slmanager.lastName:'' }}</p>
        <p>Dotted line manager : {{ review.dlmanager!=undefined?review.dlmanager.firstName:'' }} {{ review.dlmanager!=undefined?review.dlmanager.lastName:'' }}</p>

        <p>First part step : <v-select :items="items" item-text="label" item-value="code" v-model="review.reviewFirstPart.status.code"></v-select>
        </p>
        <p>Second part step : <v-select :items="items" item-text="label" item-value="code" v-model="review.reviewSecondPart.status.code"></v-select>
        </p>
        <p>
          <v-btn @click="confirm" color="success">Validate</v-btn>
          <v-btn @click="back" color="warning">Return</v-btn>
        </p>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline"><span>Confirmation </span></v-card-title>
        <v-card-text>
          <v-container>
            <span>Change worflow step to <br />
              First part : {{ getStatusFromCode(review.reviewFirstPart.status.code).label }}<br />
              Second part : {{ getStatusFromCode(review.reviewSecondPart.status.code).label }}
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">No</v-btn>
          <v-btn color="orange darken-1" text @click="validate()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</div>
</template>

<script>
export default {
  name: 'ReviewsWorkflow',
  data() {
    return {
      isMsg: false,
      message: '',
      error: false,
      dialog: false,
      items: [{
          code: 'EMP_PROP',
          label: '1- Employee proposal'
        },
        {
          code: 'SLM_PROP',
          label: '2- Strong line proposal'
        },
        {
          code: 'DLM_VAL',
          label: '3- Dotted line validation'
        },
        {
          code: 'SLM_BACK',
          label: '4- Return Strong line manager'
        },
        {
          code: 'EMP_NOTIF',
          label: '5- Employee notification'
        },
        {
          code: 'CLOSED',
          label: '6- Closed'
        },
        {
          code: 'CLOSED_HR',
          label: '7-Closed by HR'
        },
      ],
      review: null,
      reviewWorkflowDto: {}

    }
  },
  methods: {
  getColor: function () {
    if (this.error) {
      return "red darken-2";
    } else {
      return "green darken-2";
    }
  },
    back() {
      this.$router.back();
    },
    getStatusFromCode(code) {
      var item;
      for (item of this.items) {
        if (item.code == code) {
          return item;
        }
      }
    },

    confirm() {
      this.dialog = true;
    },
    validate() {
      this.reviewWorkflowDto.reviewId = this.$route.params.id;
      this.reviewWorkflowDto.statusFirstPart = this.getStatusFromCode(this.review.reviewFirstPart.status.code);
      this.reviewWorkflowDto.statusSecondPart = this.getStatusFromCode(this.review.reviewSecondPart.status.code);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/workflow", {
        method: 'PUT',
        credentials: 'include',
        headers: myHeaders,
        body: JSON.stringify(this.reviewWorkflowDto)
      }).then((response) => {
        this.dialog = false;
        return response.json();
      }).then(json => {
        this.message = json.data;
        this.isMsg = true;
      })
    },
    loadReviews() {
      this.year = this.currentCampaign;
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/" + this.$route.params.id, {
          method: 'GET',
          credentials: 'include',
        })
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          }
        })
        .then((json) => {
          if (json) {
            this.review = json.data;
          }
        });
    }
  },
  mounted: function () {
    this.loadReviews();
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}

.btn-action-review {
  min-width: 32px !important;
}
</style>
